module.exports = __webpack_public_path__ + "img/bottomList0.9846f657.svg";